import React, { useState, useEffect } from 'react';
import apiGatewayService from '../../common/services/apiGatewayService';
import {
  Modal,
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  InputLabel,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PropaneSharp } from '@mui/icons-material';

const ApiIntegrationSelectorOption = ({ isOpen, handleClose, submitSelection, apiIntegration, titleInput, optionId, isEditInput }) => {
  const [title, setTitle] = useState('');
  const [search, setSearch] = useState('');
  const [type, setType] = useState('');
  const [availableIntegrations, setAvailableIntegrations] = useState([]);
  const [selectedIntegration, setSelectedIntegration] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const typeOptions = ['API Endpoint', 'Webhook'];

  useEffect(() => {
    const fetchIntegrations = async () => {
      setIsLoading(true);
      try {
        const response = await apiGatewayService.getApi();
        console.log("response: ", response);
        const integrationsMapped = response.data.map((integration) => integration.value);
        setAvailableIntegrations(integrationsMapped);
      } catch (error) {
        console.error("Error fetching integrations:", error);
      }
      setIsLoading(false);
    };

    fetchIntegrations();
    console.log('api Integration: ', apiIntegration);
    if (apiIntegration !== null) {
      setTitle(titleInput);
      setType(apiIntegration.type);
      setSelectedIntegration(apiIntegration.key);
    };
    if (isEditInput){
      setIsEdit(true);
    }
  }, []);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  const handleIntegrationChange = (event) => {
    setSelectedIntegration(event.target.value);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSubmit = async () => {
    const selection = {
      displayName: title,
      values: {apiIntegration : {
        type,
        key: selectedIntegration,
      }}
    };
    setIsLoading(true);
    console.log("isEdit: ", isEdit);

    try {
      if (isEdit) {
        await apiGatewayService.putOptionsData(optionId, selection, 'api');
      } else {
        await apiGatewayService.postOptionsData(selection, 'api');
      }

      //submitSelection(selection);
      handleClose();
    } catch (error) {
      console.log('Error in submitting form api options: ', error);
    }
    setIsLoading(false);
  };

  const filteredIntegrations = availableIntegrations.filter((integration) =>
    integration.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="custom-url-selection-title"
      aria-describedby="custom-url-selection-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
          width: '400px',
          outline: 'none',
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <h2>Integrations</h2>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress sx={{ color: 'var(--app-color)' }} />
          </Box>
        ) : (
          <>
          {/* <InputLabel sx={{ marginBottom: '8px' }}>Title</InputLabel> */}
            <TextField
              fullWidth
              variant="outlined"
              // label="Title"
              placeholder="Title"
              value={title}
              onChange={handleTitleChange}
              sx={{
                marginBottom: '16px',
                "& .MuiInputBase-root": {
                  height: 40,
                  backgroundColor: 'white',
                },
                "& .MuiOutlinedInput-input": {
                  height: 40,
                  width: '100%',
                },
              }}
            />

            {/* <InputLabel sx={{ marginBottom: '8px' }}>Type</InputLabel> */}
            <Select
              fullWidth
              value={type}
              onChange={handleTypeChange}
              displayEmpty
              sx={{ height: '40px', backgroundColor: 'white', marginBottom: '16px' }}
            >
              <MenuItem value="" disabled>
                <em>Select type</em>
              </MenuItem>
              {typeOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
              sx={{
                marginBottom: '16px',
                "& .MuiInputBase-root": {
                  height: 40,
                  backgroundColor: 'white',
                },
                "& .MuiOutlinedInput-input": {
                  height: 40,
                  width: '100%',
                },
              }}
            />

            {/* <InputLabel sx={{ marginBottom: '8px' }}>Integration</InputLabel> */}
            <Select
              fullWidth
              value={selectedIntegration}
              onChange={handleIntegrationChange}
              displayEmpty
              sx={{ height: '40px', backgroundColor: 'white', marginBottom: '16px' }}
            >
              <MenuItem value="" disabled>
                <em>Select integration</em>
              </MenuItem>
              {filteredIntegrations.map((integration, index) => (
                <MenuItem key={index} value={integration.name}>
                  {integration.name}
                </MenuItem>
              ))}
            </Select>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{
                backgroundColor: 'var(--button-color)',
                color: 'white',
                fontWeight: 'normal',
                textTransform: 'none',
                ":hover": {
                  backgroundColor: 'var(--button-hover-color)',
                },
              }}
            >
              Submit
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ApiIntegrationSelectorOption;
